export const getTypeName = (relatedType: number, reference = "") => {
	switch (relatedType) {
		case 0:
			return "Adjustment";
		case 1:
			return "Login Streak";
		case 2:
			return "Refer a Friend";
		case 3:
			return "Clash";
		case 4:
			return "Registration";
		case 8:
			return "Free Coins";
		case 9:
			return "Buy Coins";
		case 10:
			return "Challenge Reward";
		case 11:
			return "Mini Game Reward";
		case 12:
			return "Entry Fee";
		case 13:
			return "Swap Coins";
		case 14:
			if (reference === "REDEEMCODE") return "Redeem Code";
			return "Prize Reward";
		case 15:
			return "Fast Track Training";
		case 16:
			return "Profile Complete";
		case 17:
			return "All Access Pass";
		case 19:
			return "Game Provider Fee";
		case 20:
			return "Game Provider Prize";
		case 21:
			return "Buy Contract";
		case 27:
			return "Promotion";
		default:
			return "?";
	}
};
